// ReSharper disable once InconsistentNaming
var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var auth;
        (function (auth) {
            var PermissionService = (function () {
                function PermissionService($rootScope) {
                    this.$rootScope = $rootScope;
                    this.userInfo = null;
                    this.PermissionList = [];
                }
                PermissionService.prototype.setPermissions = function (permissions) {
                    this.PermissionList = permissions;
                    this.$rootScope.$broadcast('permissionsChanged');
                };
                PermissionService.prototype.init = function () { };
                PermissionService.prototype.hasPermission = function (permission) {
                    var $this = this;
                    if (permission === null || permission === undefined) {
                        return true;
                    } 
                    if ((!this.PermissionList || !this.PermissionList.length) && (this.userInfo === null || this.userInfo === undefined || !this.userInfo.Roles)) {
                        var auth1 = JSON.parse(window.localStorage.getItem('authenticationInfo'));
                        if (auth1) {
                            this.userInfo = auth1.userInfo;
                        }
                        if (this.userInfo && this.userInfo) {
                            this.PermissionList = this.userInfo.Roles;
                        }
                    }
                    if (Array.isArray(permission)) {
                        if (!permission.length) {
                            return true;
                        }
                        else {
                            return permission.filter(function (n) { return ($this.PermissionList.indexOf(n) !== -1); }).length > 0;
                        }
                    }
                    if (this.PermissionList && this.PermissionList.indexOf('Administrator') !== -1) {
                        return true;
                    }
                    if (!this.PermissionList || this.PermissionList.length === 0) {
                        return false;
                    }
                    permission = permission.trim();
                    if (this.PermissionList.indexOf(permission) !== -1) {
                        return true;
                    }
                    return false;
                };
                PermissionService.$inject = ['$rootScope'];
                return PermissionService;
            })();
            auth.PermissionService = PermissionService;
            angular.module("jcsfApp")
                .service("PermissionService", jcsfApp.app.auth.PermissionService);
        })(auth = app.auth || (app.auth = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
